<div>{{'twinning.desc' | translate}}</div>
<div *ngFor="let nr of euNumbers" fxLayout="row" fxLayoutAlign="space-between center" class="twinning-entry">
  <div fxLayout="row">
    {{nr.fullNumber | phoneNumberFormatter}}
    <div *ngIf="nr.idx === 0">&nbsp;({{'twinning.primary' | translate}})</div>
  </div>
  <mat-slide-toggle [checked]="nr.enabled"
                    [disabled]="nr.idx === 0"
                    (change)="toggleNumber(nr, $event.source.checked)"
                    color="primary">
  </mat-slide-toggle>
</div>
